import { useState, useEffect, memo } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Button, Table, Tag, message, Select, Icon } from 'mk-pc'
import { DeleteModal, CommonStatus } from '@mk/core'
import { AppSelector } from '@/components'
import { EditNav } from '../components'
import { queryNavList, deleteNav } from '../service'
import '../styles/main.scss'

/**
 * 导航
 */
export const NavMgmt = memo(() => {
  const [messageApi, contextHolder] = message.useMessage()
  const [edit, setEdit] = useState<{ value: string; visible: boolean }>({ value: '', visible: false })
  const [deleteModal, setDeleteModal] = useState<{ visible: boolean; value: any; message: string }>({ visible: false, value: null, message: '' })
  const [searchParams, setSearchParams] = useState<{ appId?: string; status?: number; type?: number }>({ status: 1 })
  const [list, setList] = useState([] as any)

  useEffect(() => {
    fetchData()
  }, [searchParams])

  /**
   * 获取导航列表
   */
  const fetchData = async () => {
    const result = await queryNavList(searchParams)
    setList(result)
  }

  /**
   * 删除
   */
  const handleDelete = async (row: any) => {
    if (!row) return
    setDeleteModal({
      visible: true,
      value: row,
      message: `删除导航【${row.name}】记录，是否继续？`
    })

    return true
  }

  /**
   * 删除确认
   */
  const onDeleteConfirm = async () => {
    if (!deleteModal.value) return false

    await deleteNav(deleteModal.value.id)

    fetchData()

    setDeleteModal({ visible: false, value: null, message: '' })

    messageApi.open({
      type: 'success',
      content: '删除成功'
    })

    return true
  }

  /**
   * 监听关闭
   */
  const onEditClose = (isRefresh?: boolean) => {
    setEdit((state) => ({ ...state, visible: false }))
    if (isRefresh) {
      fetchData()
    }
  }

  return (
    <section className="org-nav">
      {contextHolder}
      <div className="org-nav__search">
        <div className="form">
          <AppSelector style={{ width: 160 }} value={searchParams.appId} onChange={(e: string) => setSearchParams({ ...searchParams, appId: e })} />
          <Select
            value={searchParams.status}
            placeholder="选择状态"
            style={{ width: 160 }}
            options={[
              { value: -1, label: '全部' },
              { value: 1, label: '启用' },
              { value: 0, label: '停用' }
            ]}
            onChange={(e: any) => setSearchParams({ ...searchParams, status: e })}
          />
        </div>
        <Button type="primary" onClick={() => setEdit({ value: '', visible: true })}>
          创建导航
        </Button>
      </div>
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <Table dataSource={list} scroll={{ x: 'max-content' }} pagination={false}>
          <Table.Column title="导航编码" dataIndex="code" key="code" width={160} />
          <Table.Column title="导航名称" dataIndex="name" key="name" width={160} />
          <Table.Column
            title="类型"
            dataIndex="type"
            key="type"
            width={160}
            render={(_: any, record: any) => {
              return record.type === 1 ? <Tag color="blue">模块导航</Tag> : <Tag>普通导航</Tag>
            }}
          />
          <Table.Column title="路径" dataIndex="path" key="path" width={200} />
          <Table.Column title="排序" dataIndex="order" key="order" width={100} />
          <Table.Column
            title="状态"
            dataIndex="status"
            key="status"
            width={100}
            render={(_: any, record: any) => <CommonStatus status={record.status} />}
          />
          <Table.Column
            title="操作"
            key="action"
            align="center"
            fixed="right"
            className="table-operatebtn"
            width={200}
            render={(_: any, record: any) => (
              <>
                <Button type="link" onClick={() => setEdit({ value: record.id, visible: true })}>
                  <Icon name="icon-edit" />
                  编辑
                </Button>
                <Button type="link">
                  <Icon name="icon-adjust" />
                  权限
                </Button>
                <Button type="link" onClick={() => handleDelete(record)}>
                  <Icon name="icon-ashbin" /> 删除
                </Button>
              </>
            )}
          />
        </Table>
      </div>
      <EditNav visible={edit.visible} value={edit.value} onClose={onEditClose} />
      {/* <NavAction visible={editVisible} /> */}
      <DeleteModal
        visible={deleteModal.visible}
        message={deleteModal.message}
        onClose={() => setDeleteModal({ ...deleteModal, visible: false, message: '' })}
        onConfirm={onDeleteConfirm}
      />
    </section>
  )
})
